<style>
    .v-stepper__step v-stepper__step--complete .v-stepper__step__step primary i {
        color: green
    }
</style>
<template>
    <v-container-fluid>
        <div class="row" eager>
            <div class="col-md-12">
                <v-card>
                    <v-card-title class="justify-center">
                        <h4 class="header mr-5 justify-start" eager>
                            Informed Delivery   </h4>    <v-menu v-model="AddArt"
        :close-on-content-click="false"
        :nudge-width="1000"
        @close="ClearForm"
        :close-on-click="false"
        class="ml-3 mb-3"
        :loading="IsSubmittingArt">
  
            <template v-slot:activator="{ on, attrs }">
                <v-btn color="black"
                       icon
                       large
                       class="ml-5"
                       v-bind="attrs"
                       v-on="on">
                    <v-icon small>mdi-image-album</v-icon>
                </v-btn>
                <span class="header">Add Art</span>
            </template>
   
            <v-card>
                <v-toolbar>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn icon
                               dark
                               @click="ClearForm">
                            <v-icon color="primary">mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-divider></v-divider>
                <div class="container" offset-x >
                    <validation-observer ref="observer">
                        <v-form @submit.prevent="submit" class="p-1" enctype="multipart/form-data">
                            <v-stepper v-model="CurrentStep" class="mt-2">
                                <v-stepper-header class="mb-5">
                                    <v-stepper-step :complete="CurrentStep > 1"
                                                    step="1">
                                        Art Details
                                    </v-stepper-step>
                                    <v-divider></v-divider>
                                    <v-stepper-step :complete="CurrentStep > 2"
                                                    step="2">
                                        Add Images
                                    </v-stepper-step>
                                    <v-divider v-if="SubmitArt.AddNotes"></v-divider>
                                    <v-stepper-step :complete="CurrentStep > 3"
                                                    step="3" v-if="SubmitArt.AddNotes">
                                        Add Notes
                                    </v-stepper-step>
                                </v-stepper-header>
                                <v-stepper-items>
                                    <v-stepper-content step="1" tile>
                                        <div class="mb-12"
                                             height="725px">
                                            <validation-provider v-slot="{ errors }" name="Job Number" rules="required">
                                                <v-combobox v-model="SubmitArt.JobNumber"
                                                            :items="AvailableJobs"
                                                            outlined
                                                            dense
                                                            class="mt-3"
                                                            chips
                                                            eager
                                                            @input="GetDisplayName"
                                                            @paste="GetDisplayName"
                                                            :error-messages="errors"
                                                            label="Select Job#"
                                                            prepend-icon="mdi-hammer-wrench"
                                                            clearable></v-combobox>
                                            </validation-provider>

                                            <validation-provider v-slot="{ errors }" name="Image Title" rules="required|min:5|max:30" github>
                                                <v-text-field label="Display Name"
                                                              v-model="SubmitArt.DisplayName"
                                                              required
                                                              class="mb-2"
                                                              clearable
                                                              counter
                                                              :error-messages="errors"
                                                              prepend-icon="mdi-format-title" />
                                            </validation-provider>
                                            <validation-provider v-slot="{ errors }" name="ImageUrl" rules="required|IsValidUrl" mode=aggressive>
                                                <v-text-field label="Url"
                                                              prepend-icon="mdi-search-web"
                                                              v-model="SubmitArt.ImageUrl"
                                                              :error-messages="errors" />
                                            </validation-provider>
                                        </div>
                                        <v-card-actions class="justify-end">
                                            <v-btn @click="ClearForm" color="primary" outlined class="mr-2">
                                                Cancel
                                            </v-btn>
                                            <v-btn color="primary"
                                                   @click="CurrentStep = 2">
                                                Continue
                                            </v-btn>
                                        </v-card-actions>
                                    </v-stepper-content>
                                    <v-stepper-content step="2">
                                        <v-row justify="space-around" v-if="EditMode" class="mb-2">
                                            <div class="col-md-6">
                                                <label>Rep Image</label>
                                                <v-img :src="SubmitArt.RepOriginal" max-height="500px" width="100%"
                                                       aspect-ratio="1.7" eager></v-img>
                                            </div>
                                            <div class="col-md-6">
                                                <label>Ride Along Image</label>
                                                <v-img :src="SubmitArt.RideAlongOriginal" max-height="500px" width="100%"
                                                       aspect-ratio="1.7" eager></v-img>
                                            </div>
                                        </v-row>

                                        <v-card class="mt-3" :height="SubmitArt.ReplaceRideAlong ? '350px' : '300px'">
                                            <v-container class="px-0 my-0 py-0"
                                                         fluid>
                                                <v-checkbox v-model="SubmitArt.ReplaceRep"
                                                            label="Replace Rep Image" v-if="EditMode"></v-checkbox>
                                            </v-container>
                                            <validation-provider v-slot="{ errors }" name="Rep Image" rules="required|size:200|IsValidRep:780,500,350,500|mimes:image/jpeg" class="mt-2 mb-5" v-if="!EditMode || SubmitArt.ReplaceRep">
                                                <v-file-input chips
                                                              ref="SubmitRepImage"
                                                              :error-messages="errors"
                                                              outlined
                                                              show-size
                                                              v-model="SubmitArt.RepImage"
                                                              dense
                                                              label="Represenative Image"></v-file-input>
                                            </validation-provider>
                                            <v-container class="px-0 my-0 py-0"
                                                         fluid>
                                                <v-checkbox v-model="SubmitArt.ReplaceRideAlong"
                                                            label="Replace Ride Along Image" v-if="EditMode"></v-checkbox>
                                            </v-container>
                                            <validation-provider v-slot="{ errors }"
                                                                 name="Ride Along Image" rules="required|size:200|dimensions:300,200|mimes:image/jpeg" class="mt-5" v-if="!EditMode ||SubmitArt.ReplaceRideAlong">
                                                <v-file-input chips
                                                              ref="SubmitRideAlongImage"
                                                              outlined
                                                              v-model="SubmitArt.RideAlongImage"
                                                              show-size
                                                              dense
                                                              :error-messages="errors"
                                                              label="Ride Along Image"></v-file-input>
                                            </validation-provider>
                                            <v-container class="px-0 my-0 py-0"
                                                         fluid>
                                                <v-checkbox v-model="SubmitArt.AddNotes"
                                                            label="Add Special Notes" v-on:change="AddDefaultNotes"></v-checkbox>
                                            </v-container>
                                            <v-card-actions class="justify-end mb-2">
                                                <v-btn @click="CurrentStep = 1" color="primary" outlined>
                                                    Back
                                                </v-btn>

                                                <v-btn color="primary" flat @click="submit" v-if="!SubmitArt.AddNotes">
                                                    {{SubmitText}}
                                                </v-btn>
                                                <v-btn color="primary" flat v-on:click='CurrentStep = 3' :disabled="IsSubmittingArt" v-if="SubmitArt.AddNotes">
                                                    Add Notes
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-stepper-content>
                                    <v-stepper-content step="3" tile eager>
                                        <v-card class="mt-3" height="600px">
                                            <ckeditor v-model="SubmitArt.AdditionalNotes" :config="editorConfig">
                                            </ckeditor>
                                            <v-card-actions class="justify-end">
                                                <v-btn @click="CurrentStep = 2" color="warning" outlined>
                                                    Back
                                                </v-btn>
                                                <v-btn @click="ClearForm" color="primary" outlined class="mr-4">
                                                    Cancel
                                                </v-btn>
                                                <v-btn color="primary"
                                                       v-on:click="submit" :disabled="IsSubmittingArt">
                                                    {{SubmitText}}
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-stepper-content>
                                </v-stepper-items>
                            </v-stepper>
                        </v-form>
                    </validation-observer>

                </div>
            </v-card>
</v-menu>
                                     </v-card-title>
                    <v-row>
                        <div class="col-md-12 mt-2">
                            <v-toolbar flat dense>
                                <v-toolbar-items>
                                    <v-chip small outlined color="black" v-if="StartDate && EndDate">
                                        Showing Dates: <i> <b> {{StartDate}} thru {{EndDate}}</b> </i>
                                    </v-chip>
                                </v-toolbar-items>
                                <div class="flex-grow-1"></div>
                                <v-toolbar-items>
                                    <v-select v-model="SelectedDpStatus"
                                              :items="DpTicketStatuses"
                                              :menu-props="{ maxHeight: '400' }"
                                              label="Process Status"
                                              multiple
                                              item-text="dpStatusDescription"
                                              item-value="dpStatusId"
                                              clearable 
                                              class="mr-3"
                                              v-on:change="FilterArt(false)"></v-select>

                                    <v-menu ref="menu"
                                            v-model="menu"
                                            :close-on-content-click="false"
                                            :return-value.sync="dates"
                                            transition="scale-transition"
                                            offset-y
                                            eager
                                            min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="dateRangeText"
                                                          label="Search Dates"
                                                          prepend-icon="mdi-calendar"
                                                          readonly
                                                          v-bind="attrs"
                                                          v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="dates"
                                                       no-title
                                                       range
                                                       outlined
                                                       scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn text color="warning" @click="FilterArt(true)">
                                                Clear
                                            </v-btn>
                                            <v-btn text
                                                   color="primary"
                                                   @click="menu = false">
                                                Cancel
                                            </v-btn>
                                            <v-btn text
                                                   color="primary"
                                                   @click="FilterArt(false)">
                                                OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                    <v-text-field v-model="searchFilter" append-icon="mdi-magnify"
                                                  label="Search"
                                                  single-line
                                                  class="ml-5 mr-5 mt-1"
                                                  dense
                                                  small
                                                  v-on:change="FilterArt"
                                                  hide-details
                                                  clearable>
                                    </v-text-field>
                                </v-toolbar-items>
                            </v-toolbar>
                            <div class="row justify-center my-auto" v-if="PageLoading">

                                <v-progress-circular indeterminate
                                                     color="success" class="text-center">
                                </v-progress-circular>
                            </div>
                            <v-data-table :headers="headers"
                                          :items="VendorArt"
                                          multi-sort
                                          :search="searchFilter"
                                          dense
                                          v-if="!PageLoading">
                                <template v-slot:item.images="{ item }">
                                    <v-chip color="black"
                                            outlined
                                            class="mr-2"
                                            small style="cursor:pointer" v-on:click="PreviewImage('Ride Along',item.ride_Along_Pic)">
                                        Ride Along Image
                                    </v-chip>
                                    <v-chip color="black"
                                            small class="white--text" style="cursor:pointer" v-on:click="PreviewImage('Rep Image', item.rep_Pic)">
                                        Rep Image
                                    </v-chip>
                                </template>
                                <!--<template v-slot:item.title="{ item }">
            <v-chip color="black"
                    outlined
                    small>
                {{ item.title }}
            </v-chip>
        </template>-->

                                <template v-slot:item.dpTicketStatus="{ item }">
                                    <v-chip color="#039BE5"
                                            outlined
                                            small
                                            v-if="item.ticketStatus == 4">
                                        {{ item.dpTicketStatus }}
                                        <v-icon small class="ml-1">mdi-gesture-tap-hold</v-icon>
                                    </v-chip>
                                    <v-chip color="danger"
                                            outlined
                                            small
                                            v-if="item.ticketStatus == 3">
                                        {{ item.dpTicketStatus }}
                                        <v-icon small class="ml-1">mdi-file-cancel</v-icon>
                                    </v-chip>
                                    <v-chip color="#00BFA5"
                                            outlined
                                            small
                                            v-if="item.ticketStatus == 1">
                                        {{ item.dpTicketStatus }}
                                        <v-icon small class="ml-1">mdi-folder-open</v-icon>
                                    </v-chip>
                                    <v-chip color="success"
                                            outlined
                                            small
                                            v-if="item.ticketStatus == 2">
                                        {{ item.dpTicketStatus }}
                                        <v-icon small class="ml-1">mdi-checkbox-marked-circle</v-icon>
                                    </v-chip>
                                </template>
                                <template v-slot:item.displayName="{ item }">
                                    <v-chip color="black"
                                            small class="white--text">
                                        {{ item.displayName }}
                                    </v-chip>
                                </template>
                                <template v-slot:item.jobNumber="{ item }">
                                    <label v-if="IsInternalUser"> {{item.jobNumber}} </label>
                                    <label v-if="!IsInternalUser">>  {{item.vendorJobNumber}} </label>
                                </template>
                                <template v-slot:item.actions="{item}">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon
                                                   v-bind="attrs"
                                                   color="warning"
                                                   v-on="on">
                                                <v-icon v-on:click="ShowJobDetails(item)">mdi-file-search</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Detailed View</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon
                                                   v-bind="attrs"
                                                   color="black"
                                                   :disabled="item.ticketStatus == 2"
                                                   v-on="on">
                                                <v-icon v-on:click="EditItem(item)">mdi-grease-pencil</v-icon>
                                            </v-btn>
                                        </template>
                                        <span v-if="item.ticketStatus != 2">Edit Item</span>
                                        <span v-if="item.ticketStatus == 2">Item Locked - Job has been processed</span>
                                    </v-tooltip>
                                    <v-tooltip top class="ml-1">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon
                                                   :disabled="item.ticketStatus == 2"
                                                   v-bind="attrs"
                                                   color="error"
                                                   v-on="on">
                                                <v-icon v-on:click="RemoveItem(item)">mdi-trash-can</v-icon>
                                            </v-btn>
                                        </template>
                                        <span v-if="item.ticketStatus != 2">Delete Item</span>
                                        <span v-if="item.ticketStatus == 2">Item Locked - Job has been processed</span>
                                    </v-tooltip>
                                </template>
                                <template v-slot:item.url="{ item }">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <a :href="item.url" target="_blank" style="cursor:pointer">
                                                <v-icon class="ml-1 mr-1">mdi-search-web</v-icon>    {{ item.url }}
                                            </a>
                                        </template>
                                        <span>Preview Url</span>
                                    </v-tooltip>
                                </template>
                            </v-data-table>
                        </div>
                    </v-row>
                </v-card>
            </div>
        </div>

        <v-dialog v-model="ImageDialog"
                  max-width="70%"
                  :loading="ImageLoading"
                  transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark>

                    <v-toolbar-title> <v-chip color="warning"> {{ImageTitle}} </v-chip>  </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon
                           dark
                           @click="ImageDialog = false">
                        <v-icon color="warning">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-container fluid>
                    <v-row justify="space-around">
                        <div class="col-md-12">
                            <v-img :src="ImageUrl" height="100%" width="100%"
                                   aspect-ratio="1.7" v-if="!ImageLoading"></v-img>

                            <div class="text-center">
                                <v-progress-circular :size="80"
                                                     color="success"
                                                     class="justify-center"
                                                     indeterminate v-if="ImageLoading"></v-progress-circular>
                            </div>
                            <!--<img :src="'data:image/jpg;base64,' + ImageUrl" height="100%" width="100%" />-->
                        </div>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>

        <v-dialog v-model="CancelDialog"
                  max-width="600" :loading="IsDeleting">
            <v-card>
                <v-card-title class="text-h5">
                    Are you sure you want to cancel this record?
                </v-card-title>
                <v-card-text>
                    This will remove the selected entry for processing
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="error"
                           outlined
                           @click="CancelDialog = false">
                        Cancel
                    </v-btn>

                    <v-btn color="error"
                           @click="DeleteItem">
                        Remove
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="JobDetailsDialog"
                  max-width="80%"
                  :loading="JobLoading"
                  eager
                  transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark>

                    <v-toolbar-title> <v-chip color="warning" small> Job Details </v-chip>  </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon
                           dark
                           @click="JobDetailsDialog = false">
                        <v-icon color="warning">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-container fluid v-if="DetailItem">
                    <v-row justify="space-around">
                        <div class="text-center">
                            <v-progress-circular :size="50"
                                                 color="primary"
                                                 indeterminate v-if="JobLoading"></v-progress-circular>
                        </div>
                        <div class="col-md-6">
                            <v-img :src="DetailItem.Rep" max-height="100%" max-width="100%"
                                   aspect-ratio="1.7" v-if="!JobLoading"></v-img>
                        </div>

                        <div class="col-md-6">
                            <v-img :src="DetailItem.RideAlong" max-height="100%" max-width="100%"
                                   aspect-ratio="1.7" v-if="!JobLoading"></v-img>
                        </div>
                    </v-row>

                    <v-row>
                        <v-list dense subheader
                                two-line>
                            <v-subheader class="text-center">Job Detail Info</v-subheader>
                            <v-list-item-group color="primary">

                                <v-list-item>
                                    <v-list-item-icon>
                                        <v-icon>mdi-script-text</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Title</v-list-item-title>
                                        <v-list-item-subtitle v-text="DetailItem.Title"></v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item>
                                    <v-list-item-icon>
                                        <v-icon>mdi-search-web</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Url</v-list-item-title>
                                        <v-list-item-subtitle v-text="DetailItem.Url"></v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item>
                                    <v-list-item-icon>
                                        <v-icon>mdi-hammer-screwdriver</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Job#</v-list-item-title>
                                        <v-list-item-subtitle v-text="DetailItem.JobNumber"></v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item>
                                    <v-list-item-icon>
                                        <v-icon>mdi-book-open-variant</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Display Name</v-list-item-title>
                                        <v-list-item-subtitle v-text="DetailItem.DisplayName"></v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="ResponseMessage.Show"
                    shaped
                    top
                    right
                    :timeout="1500"
                    :color="ResponseMessage.Color"
                    >
            {{ ResponseMessage.Text }}
        </v-snackbar>
    </v-container-fluid>
</template>



<script>
   import store from '../plugins/store.js';
   import Vue from 'vue';
   import CKEditor from 'ckeditor4-vue';
   Vue.use( CKEditor );

    import {
        extend, //eslint-disable-line no-unused-vars
        ValidationProvider,
        ValidationObserver
       
      //eslint-disable-line no-unused-vars
    } from 'vee-validate/dist/vee-validate.full'; //eslint-disable-line no-unused-vars

   import { required, dimensions } from 'vee-validate/dist/rules'; //eslint-disable-line no-unused-vars

    extend('required', required);
    extend('mimes', {message:"This Image Must Be A JPEG Image Ex: myimage.jpg"});
    extend('dimensions', {message: 'Image Must Be 300(W) & 200px (H)'});


   extend('IsValidUrl', {
        message: "This Is Not A Valid Url Ex: http://www.youtube.com",
        validate: (input) => {
            return is_url(input);
        }
   })

    extend('IsValidRep', {
        message: "Acceptable Dimensions: \n 780px(W) X 500px(H)\n or 350px(W) x 500(H)",
        validate: (file, [width, height, secondaryWidth, secondaryHeight]) => {
        
            const validateImage = (file, width, height, secondaryWidth, secondaryHeight) => {
                const URL = window.URL || window.webkitURL;
                return new Promise(resolve => {
                    const image = new Image();
                    image.onerror = () => resolve({ valid: false });
                    image.onload = () => resolve({
                        valid: (image.width <= Number(width) && image.height <= Number(height)) || (image.width <= Number(secondaryWidth) && image.height <= Number(secondaryHeight))  // only change from official rule
                    });

                    image.src = URL.createObjectURL(file);
                });
            };

            var validate = validateImage(file, width, height, secondaryWidth, secondaryHeight);
            return validate;
         }         
    })


    export default {
        components: {
            ValidationProvider,
            ValidationObserver
        }, inject: {
            theme: {
                default: { isDark: false },
            },
        },
        data: () => ({
            AddArt: false,
            userName: ''
            ,
                editorConfig: {
                    // The configuration of the editor.
                },
          PageLoading: true,
          headers: [
          { text: 'Title', value: 'vendorJobNumber' },
          { text: 'Display Name', value: 'displayName' },
          { text: 'Images', value: 'images' },
          { text: 'Url Link', value: 'url' },
          { text: 'Job #', value: 'jobNumber' },
          { text: 'Status', value: 'dpTicketStatus' },
          { text: 'Submitted By', value: 'submittedBy' },
          { text: 'Submitted On', value: 'createdOn' },
          { text: '', value: 'actions' },
            ],
            dates: [],
            StartDate: null,
            EndDate:null,
            menu: false,
            CancelDialog: false,
            CancelItem: {
                Index: '',
                ApprovalId: '',
                RideAlong: '',
                RepImage:''
            },
            ResponseMessage: {
                Show: false,
                Text: '',
                Color:''
            },
            SubmitArt:{
                JobNumber: '',
                ImageTitle: '',
                Url: '',
                RepImage: null,
                RideAlongImage: null,
                ArtId: '',
                AdditionalNotes: '',
                AddNotes: false
            },
            CurrentStep: 1,
            CreatedJobNumber:'',
            AvailableJobs:[],
            IsDeleting: false,
            DetailItem: {},
            ActionText: 'Login',
            ImageTitle: null,
            IsInternalUser:'',
            ImageDialog: false,
            JobDetailsDialog: false,
            JobLoading: false,
            ImageLoading: false,
            SelectedImageName: '',
            BaseUrlPath:null,
            ImageUrl: null,
            RepImage: null,
            UrlLoading:false,
            RidAlongImage: null,
            showPass: false,
            PreviewUrlDialog: false,
            isAuthorized: false,
            hasAuthorizationError: false,
            waitingForfResp: false,
            stateData: '',
            moduleKey: '',
            PreviewUrl: '',
            UpdateImages: false,
            JobNumber: '',
            SelectedDpStatus:[],
            DpTicketStatuses:[],
            VendorArt: [],
            EditMode: false,
            searchFilter: null,
            loggingIn: false,
            loginSuccess: true,
            IsSubmittingArt: false,
            SubmitText:'Submit Art',
            AvailableJobNumbers:[]
        }),
        created() {
            this.FilterArt();
        },
        computed: {
            params() {
                return {
                    userName: this.userName,
                    password: this.password,
                    moduleKey: this.$route.query.modulekey
                }
            },
            dateRangeText() {

                if (this.dates.length != 0) {
                    return this.dates.join(' ~ ')
                }
                else {
                    return null;
                }
            },
            AddArtLabel() {
                return this.AddArt ? "Add New Art" : 'View Submitted Art'
            }
        },
      
        methods: {
            RestForm: function () {
                this.waitingForfResp = false;
                this.loggingIn = false;
                this.hasAuthorizationError = false;
                this.isAuthorized = false;
            },
            EditItem: function (item) {

                this.IsSubmittingArt = false;
                this.EditMode = true;
                this.AddArt = true;
                this. SubmitArt = {
                     DisplayName: item.displayName,
                     ImageUrl: item.url,
                     RepImage: null,
                     RideAlongImage: null,
                     ReplaceRep: false,
                     AddNotes: false,
                     ReplaceRideAlong:false,
                     ArtId: item.artId,
                     RideAlongOriginalName: item.ride_Along_Pic,
                     RideAlongOriginal: this.BaseUrlPath + item.ride_Along_Pic,
                     RepOriginalName: item.rep_Pic,
                     RepOriginal: this.BaseUrlPath + item.rep_Pic,
                     AdditionalNotes: ''
                }  

                if (this.IsInternalUser)
                    this.SubmitArt.JobNumber = item.jobNumber
                else
                 this.SubmitArt.JobNumber = item.vendorJobNumber
                 this.SubmitText = "Update Art"
                 this.CurrentStep = 1
                 this.$refs.observer.reset()
            },
            GetDisplayName: function () {
                var self = this;

                if (self.SubmitArt.JobNumber == '' || self.SubmitArt.JobNumber == null || self.SubmitArt.JobNumber == "") {
                    self.SubmitArt.DisplayName = '';
                    return;
                }

                var getBankName = this.AvailableJobNumbers.filter(x => x.vendorJobNumber == self.SubmitArt.JobNumber || x.mwiJobNumber == self.SubmitArt.JobNumber)[0];

                if ((getBankName) && getBankName.length != 0) {
                    self.SubmitArt.DisplayName = getBankName.displayName;
                    self.SubmitArt.DpTicketId = getBankName.dpTicketId
                }
                else {
                    self.$http.post('/Modules/InformedDelivery/GetJobTicketDetails',
                        {
                            JobNumber: self.SubmitArt.JobNumber
                        }).then(function (response) {
                            if (response.data.success) {
                                self.SubmitArt.DisplayName = response.data.displayName;
                                self.SubmitArt.DpTicketId = response.data.dpTicketId;
                            }
                        })
                    }
            },
            RemoveItem: function(item) {

                this.CancelItem = {};
                this.CancelItem = item;
               
                this.CancelDialog = true
            },
            DeleteItem: function () {

                var self = this;
                self.IsDeleting = true

                this.$http.post('/Modules/InformedDelivery/DeleteVendorArt',
                      {
                        VendorId: this.CancelItem.vendorId,
                        ModuleKey: self.$route.query.modulekey,
                        ImageTitles: new Array(this.CancelItem.ride_Along_Pic, this.CancelItem.rep_Pic),
                        ArtId: this.CancelItem.artId

                    }).then(function (response) {
                      
                        if (response.data.success) {
                            
                            self.ResponseMessage.Text = 'Art Successfully Removed'
                            self.ResponseMessage.Color = 'success'
                            self.ResponseMessage.Show = true
                            const index = self.VendorArt.indexOf(self.CancelItem);
                            if (index > -1) {
                               self.VendorArt.splice(index, 1);
                            }
                              self.IsDeleting = false
                        }
                        else {
                            self.IsDeleting = false
                            self.ResponseMessage.Text = 'Error Removing Art'
                            self.ResponseMessage.Color = 'error'
                            self.ResponseMessage.Show = true
                        }
                         
                           self.CancelDialog = false
                    })
            },
            PreviewImage: function (title, imageName) {
                var self = this;
                self.ImageLoading = true;
                self.ImageDialog = '';
                self.ImageTitle = '';
                self.ImageUrl = null;
                self.ImageUrl = self.BaseUrlPath + imageName;
                self.ImageDialog = true
                self.ImageTitle = title
                self.ImageLoading = false;
            },
            ShowJobDetails: function (item) {
                var self = this;
                self.JobLoading = true
                self.DetailItem = {}
                self.DetailItem.Url = item.url;
                self.DetailItem.DisplayName = item.displayName
                self.DetailItem.Title = item.vendorJobNumber
                self.DetailItem.JobNumber = item.jobNumber

                self.JobDetailsDialog = true
                var rideAlong = self.BaseUrlPath + item.ride_Along_Pic;
                var rep = self.BaseUrlPath + item.rep_Pic
                self.DetailItem.Rep = rep
                self.DetailItem.RideAlong = rideAlong
                self.JobLoading = false
            },
            AddDefaultNotes: function () {

                if (this.SubmitArt.AddNotes) {
                    this.SubmitArt.AdditionalNotes = "Please take a look at the information that will show under the Informed Delivery when mail users click into it for this bank"
                }
                else {
                    this.SubmitArt.AdditionalNotes = '';
                }
            },
            FilterArt: function (clear) {
                var self = this;
                if (clear) {
                    self.$nextTick(() => {
                        self.$refs.menu.save([])
                    })
                     self.dates = []
                }
                else {
                    self.$nextTick(() => {
                        self.$refs.menu.save(self.dates)
                    })
                 }
          
                var vendorId = self.$store.getters.user.currentCustomer.customerId
                this.$http.post('/Modules/InformedDelivery/LoadSubmittedArt',
                 {
                     Dates: self.dates,
                     SearchFilter: self.searchFilter,
                     VendorId: vendorId,
                     TicketStatus: self.SelectedDpStatus,
                     ModuleKey: self.$route.query.modulekey
                 }).then(function (response) {
                        if (response.data.success) {
                            self.DpTicketStatuses = response.data.ticketStatus;
                            self.VendorArt = response.data.vendorArt
                            self.BaseUrlPath = response.data.imageUrl
                            self.IsInternalUser = response.data.internalUser
                            self.StartDate = response.data.startDate,
                            self.EndDate = response.data.endDate
                            self.AvailableJobNumbers = response.data.availableJobs;


                            if (response.data.internalUser) {

                                var allAvailableJobs = new Array();

                                var mwiJobNumbers = response.data.availableJobs.map(x => x.mwiJobNumber);
                                var formNumbers = response.data.availableJobs.map(x => x.vendorJobNumber);

                                for (var i = 0; i < mwiJobNumbers.length; i++) {
                                    allAvailableJobs.push(mwiJobNumbers[i])
                                } 

                                for (var i = 0; i < formNumbers.length; i++) {
                                    allAvailableJobs.push(formNumbers[i])
                                }

                                self.AvailableJobs = allAvailableJobs;
                            }
                            else {
                                self.AvailableJobs = response.data.availableJobs.map(x => x.vendorJobNumber)
                            }
                        }
                        self.PageLoading = false;
                    })
            },
            ShowPreviewUrl: function (url) {
                this.UrlLoading = true
                this.PreviewUrl = null;
                this.PreviewUrl = url;
                this.PreviewUrlDialog = true;
                this.UrlLoading = false;
            },
            async submit() {
                var self = this;
                  self.IsSubmittingArt = true;
                const valid = await this.$refs.observer.validate()
                if (valid)
                {
                    self.SubmitText = this.EditMode ? 'Updating Art...' : 'Creating Art...';
                    var successText = this.EditMode ? 'Successfully Updated Art' : 'Successfully Created Art';

                    var vendorJobNumber = null;
                    var mwiJobNumber = null;

                    if (self.IsInternalUser) {
                        debugger;

                        var getAvailableJob = self.AvailableJobNumbers.filter(x => x.mwiJobNumber.trim() == self.SubmitArt.JobNumber.trim() || x.vendorJobNumber.trim() == self.SubmitArt.JobNumber.trim())[0];

                        mwiJobNumber = self.SubmitArt.JobNumber;
                        vendorJobNumber = getAvailableJob.vendorJobNumber;
                    }
                    else {
                        vendorJobNumber = self.SubmitArt.JobNumber;
                        mwiJobNumber = self.AvailableJobNumbers.filter(x => x.vendorJobNumber.trim() == self.SubmitArt.JobNumber.trim() || x.mwiJobNumber == self.SubmitArt.JobNumber.trim() )[0].mwiJobNumber;
                    }

                    var customerData =  store.state.user.currentCustomer; 

                    let formData = new FormData();

                    if (!self.EditMode) {
                        debugger;
                        formData.append("RepImage", self.$refs.SubmitRepImage.$refs.input.files[0], self.$refs.SubmitRepImage.$refs.input.files[0].name);
                        formData.append("RideAlongImage", self.$refs.SubmitRideAlongImage.$refs.input.files[0], self.$refs.SubmitRideAlongImage.$refs.input.files[0].name);
                    }

                    else {
                        if (self.SubmitArt.ReplaceRep) {
                            formData.append("RepImage", self.$refs.SubmitRepImage.$refs.input.files[0], self.$refs.SubmitRepImage.$refs.input.files[0].name);
                            formData.append("OldRepImage", self.SubmitArt.RepOriginalName);
                            formData.append("HasRepReplacement", true);
                        }
                        else {
                            formData.append("OldRepImage", self.SubmitArt.RepOriginalName);
                        }

                        if (self.SubmitArt.ReplaceRideAlong) {
                            formData.append("RideAlongImage", self.$refs.SubmitRideAlongImage.$refs.input.files[0], self.$refs.SubmitRideAlongImage.$refs.input.files[0].name);
                            formData.append("OldRideAlongImage", self.SubmitArt.RideAlongOriginalName);
                            formData.append("HasRideAlongImageReplacement", true);
                        }
                        else {
                              formData.append("OldRideAlongImage", self.SubmitArt.RideAlongOriginalName);
                        }
                    }

                    formData.append("ArtId", self.SubmitArt.ArtId);
                    formData.append("DisplayName", self.SubmitArt.DisplayName);
                    formData.append("Url", self.SubmitArt.ImageUrl);
                    formData.append("JobNumber", self.SubmitArt.JobNumber);
                    formData.append("VendorJobNumber", vendorJobNumber);
                    formData.append("MwiJobNumber", mwiJobNumber);
                    formData.append("VendorId", customerData.customerId);
                    formData.append("ModuleKey", self.$route.query.modulekey);

                    if (self.SubmitArt.AddNotes)
                         formData.append("AdditionalNotes", self.SubmitArt.AdditionalNotes);


                  await this.$http.post('/Modules/InformedDelivery/UploadArt',
                       formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                    }
                  ).then(function (response) {

                      if (response.data.successful) {
                            self.ResponseMessage.Text = successText;
                            self.ResponseMessage.Color = 'success'
                            self.ResponseMessage.Show = true
                            self.FilterArt();
                            self.ClearForm();
                        }
                        else {
                            self.ClearForm();
                        }
                    })
                }
            },
            ClearForm() {
                this.IsSubmittingArt = false;
                this.EditMode = false;
                this.UpdateImages = false;
                this.AddArt = false;
            this. SubmitArt = {
                 JobNumber: '',
                 DisplayName: '',
                 ImageUrl: '',
                 RepImage: null,
                 RideAlongImage: null,
                 ArtId: '',
                 AddNotes: false
                }  
             this.SubmitText = "Submit Art"
             this.CurrentStep = 1
             this.$refs.observer.reset()
             }
        }
    }

   function is_url(str)
   {
       str = str.endsWith('/') ? str.substr(0, str.length - 1) : str;
       str = str.endsWith('//') ? str.substr(0, str.length - 1) : str;

    var urlValidator = new RegExp(/^(ftp|http|https):\/\/[^ "]+$/);
    if (urlValidator.test(str))
    {
      return true;
    }
    else
    {
      return false;
    }
}

</script>